import Seo from "../components/common/Seo";
import Cta from "../components/common/Cta";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found — Kratos Venture Group" description="The page you are looking for could not be found." />
      <section className="relative min-h-[80vh] flex items-center kv-radial" data-testid="not-found">
        <div className="absolute inset-0 kv-grid-bg opacity-25" aria-hidden />
        <div className="relative max-w-3xl mx-auto px-6 md:px-12 text-center">
          <div className="font-mono text-sm uppercase tracking-[0.24em] text-kv-royal">Error 404</div>
          <h1 className="mt-6 font-display text-5xl md:text-7xl font-medium tracking-tight text-kv-off">Signal lost.</h1>
          <p className="mt-6 font-body text-base md:text-lg text-kv-grey max-w-lg mx-auto">
            The page you are looking for does not exist or has moved.
          </p>
          <div className="mt-10 flex justify-center gap-4">
            <Cta to="/" testId="notfound-home" arrow>Return home</Cta>
            <Cta to="/contact" variant="secondary" testId="notfound-contact">Contact us</Cta>
          </div>
        </div>
      </section>
    </>
  );
}
